import { t } from 'i18next';
import * as S from './BurgerNav.styles';
import { NavItem, NavItemKey } from './BurgerNavDrawer.types';
import { ROUTES } from '@/constants/routes';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import { LogoLink } from '@/components/LogoLink/LogoLink';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { Languages } from '@/constants/common';
import i18n from '@/i18n';

export const navItems: Record<NavItemKey, NavItem> = {
  header: {
    id: 'header',
    render: (toggleNav: () => void) => ({
      $isHead: true,
      children: (
        <>
          <LogoLink onClick={toggleNav} hasCenterAbsolute={false} />
          <S.BurgerNavClose
            data-testid={CommonTestIds.navMenu.close}
            appearance="transparent"
            hasPadding={false}
            onClick={toggleNav}
          >
            <CloseIcon width={14} />
          </S.BurgerNavClose>
        </>
      ),
    }),
  },
  shops: {
    id: 'shops',
    href: ROUTES.shops,
    translationKey: 'common.shops',
  },
  help: {
    id: 'help',
    href: ROUTES.faq,
    translationKey: 'common.help',
  },
  aboutProject: {
    id: 'about-project',
    href: ROUTES.about,
    translationKey: 'common.about_project',
  },
  termsOfUse: {
    id: 'terms-of-use',
    href: ROUTES.terms,
    translationKey: 'common.terms_of_use',
  },
  privacyPolicy: {
    id: 'privacy-policy',
    href: ROUTES.privacy,
    translationKey: 'common.privacy_policy',
  },
  advertisingOnSite: {
    id: 'advertising-on-site',
    render: (toggleNav: () => void, isDesktop?: boolean) => ({
      href: isDesktop
        ? ROUTES.advertising_landing(
            i18n.language === Languages.Az ? '' : `${Languages.Ru}.`
          )
        : ROUTES.advertising,
      as: CustomLink,
      onClick: toggleNav,
      target: '_blank',
      'data-stat': 'advertising-landing-burger-btn',
      children: t('common.advertising_on_site'),
    }),
  },
  forBusiness: {
    id: 'for-business',
    render: (toggleNav: () => void, isDesktop?: boolean) => ({
      href: ROUTES.businessLanding,
      as: CustomLink,
      onClick: toggleNav,
      ...(!isDesktop && { target: '_blank' }),
      'data-stat': isDesktop
        ? 'business-landing-burger-btn'
        : 'for_business-burger-btn',
      children: (
        <>
          {t('common.for_business')}
          <S.LabelNew>{t('common.new_label')}</S.LabelNew>
        </>
      ),
    }),
  },
};

export const BURGER_NAV_ITEMS_ORDER: NavItemKey[] = [
  'header',
  'shops',
  'help',
  'aboutProject',
  'termsOfUse',
  'privacyPolicy',
  'advertisingOnSite',
  'forBusiness',
];
